/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdresseDoublonGridDto } from './AdresseDoublonGridDto';
import {
    AdresseDoublonGridDtoFromJSON,
    AdresseDoublonGridDtoFromJSONTyped,
    AdresseDoublonGridDtoToJSON,
} from './AdresseDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface AdresseDoublonGridDtoPaginatedResults
 */
export interface AdresseDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<AdresseDoublonGridDto>}
     * @memberof AdresseDoublonGridDtoPaginatedResults
     */
    results?: Array<AdresseDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof AdresseDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the AdresseDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfAdresseDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdresseDoublonGridDtoPaginatedResultsFromJSON(json: any): AdresseDoublonGridDtoPaginatedResults {
    return AdresseDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function AdresseDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdresseDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(AdresseDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function AdresseDoublonGridDtoPaginatedResultsToJSON(value?: AdresseDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(AdresseDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

